import { stringToColor } from '@bimser/core';
import { Avatar } from 'antd';
import { IAvatarProps, ShapeTypes, SizeTypes } from './entities';
import React from 'react';

const BCAvatar: React.FC<IAvatarProps> = props => {
	const getColor = React.useCallback(() => {
		const text = props.names?.join(' ') ?? '';
		return stringToColor(text);
	}, [props.names]);

	const text = React.useMemo(() => {
		const { names = [], maxCharacter = names.length } = props;
		return names
			.slice(0, maxCharacter)
			.filter(name => name && name !== '.')
			.map(name => name[0].toUpperCase())
			.join('');
	}, [props.names, props.maxCharacter]);

	return (
		<Avatar
			{...props}
			src={props.src || undefined}
			style={{ backgroundColor: getColor() }}
		>
			{text}
		</Avatar>
	);
};

export default BCAvatar;
export { IAvatarProps, ShapeTypes, SizeTypes };
